<template>
  <div :style="{'position': 'relative', 'margin-top': $vuetify.breakpoint.smAndUp ? '48px' : '0px'}">
    <div class="hidden-xs-only">
      <div style="position: absolute;right: 5px;top: 0px;z-index: 2;">
        <transition name="fade-down" mode="out-in">
          <div v-if="!editing" style="display: inline-block;transform: translateY(-60%);">
            <v-btn @click="print" fab dark small color="blue-grey darken-2" style="display: block;">
              <v-icon dark>print</v-icon>
            </v-btn>
            <span style="display: block; text-align: center;" class="white--text">列印</span>
          </div>
        </transition>
        <transition name="fade-down" mode="out-in">
          <div v-if="!editing" style="display: inline-block;transform: translateY(-60%);">
            <v-btn @click="send" fab dark small color="blue-grey darken-2" style="display: block;">
              <v-icon dark>send</v-icon>
            </v-btn>
            <span style="display: block; text-align: center;" class="white--text">發送</span>
          </div>
        </transition>
        <div v-if="editing" style="display: inline-block;transform: translateY(-60%);">
          <v-btn @click="deleteInvoice" fab dark small color="red darken-1" >
            <v-icon>close</v-icon>
          </v-btn>
          <span style="transition: opacity .3s; display: block; text-align: center;" :class="{'hidden': !editing}">刪除</span>
        </div>
        <div style="display: inline-block;transform: translateY(-42%);">
          <v-btn @click="toggleEdit" fab dark :color="!editing ? 'blue-grey lighten-1' : 'blue-grey darken-2'" >
            <v-icon dark v-if="!editing">edit</v-icon>
            <v-icon dark v-else>arrow_downward</v-icon>
          </v-btn>
          <span style="transition: opacity .3s; display: block; text-align: center;" :class="{'white--text' : true, 'hidden': editing}">編輯</span>
        </div>
      </div>
    </div>
    <div class="hidden-sm-and-up mb-3" style="position: absolute; right: 5px; top: 5px;z-index: 1;">
      <v-btn-toggle>
        <transition name="fade" mode="out-in">
          <v-btn v-if="!editing" @click="print" flat color="blue-grey darken-2" style="display: block;">
            <v-icon dark>print</v-icon>
          </v-btn>
        </transition>
        <transition name="fade" mode="out-in">
          <v-btn @click="send" v-if="!editing" flat color="blue-grey darken-2" style="display: block;">
            <v-icon dark>send</v-icon>
          </v-btn>
        </transition>
        <v-btn v-if="editing" @click="deleteInvoice" flat color="blue-grey darken-2" >
          <v-icon dark>close</v-icon>
        </v-btn>
        <v-btn @click="toggleEdit" flat :color="!editing ? 'blue-grey lighten-1' : 'blue-grey darken-2'" >
          <v-icon dark v-if="!editing">edit</v-icon>
          <v-icon dark v-else>arrow_downward</v-icon>
        </v-btn>
      </v-btn-toggle>
    </div>
    <v-dialog
        v-model="dialog"
        width="600"
    >
      <v-card>
        <v-card-title class="headline grey lighten-4" primary-title>
          供應商訂單
        </v-card-title>
        <v-card-text>
          <div class="pa-3">
            <div @click="open(detail.file)" :key="detail.attempt_id" v-for="detail in internal_invoice_details" style="border: 1px solid #cacaca;display: flex;align-items: center;justify-content: center;height: 80px;">
              <h3 style="margin-bottom: 0;">{{ detail.supplier.name }}</h3>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red darken-1"
            flat="flat"
            @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <transition name="fade-down" mode="out-in">
      <keep-alive>
        <new-invoice-sheet :submitFunc="submit" :loading="loading" headtitle="更改訂單資料" :info="info" v-if="editing" />
        <invoice-sheet :info="info" v-else />
      </keep-alive>
    </transition>
    <v-snackbar
      v-model="snackbar"
      bottom
      :timeout="3000"
    >
      {{ error_message }}
      <v-btn
        color="error"
        flat
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import _ from 'lodash'

import NewInvoiceSheet from '@/components/NewInvoiceSheet.vue'
import InvoiceSheet from '@/components/InvoiceSheet.vue'
import { invoices } from '@/api'
import store from '@/store'

export default {
  name: 'view-invoice',
  props: ['invoice_id'],
  data () {
    return {
      info: {},
      error_message: null,
      loading: false,
      snackbar: false,

      dialog: false,
      internal_invoice_details: null
    }
  },
  components: {
    InvoiceSheet,
    NewInvoiceSheet
  },
  methods: {
    open(url) {
      window.open(url);
    },
    toggleEdit() {
      if (this.editing) this.$router.replace({ name: 'view' })
      else this.$router.push({ name: 'view', query: {edit: true} })
    },
    async print() {
      let response = await this.$store.dispatch('load', invoices.generate(this.info.invoice_id))
      window.open(response.data.printable_invoice_file.file);
    },
    async deleteInvoice() {
      let r = confirm('確定刪除訂單?')
      if (r) {
        await this.$store.dispatch('load', invoices.delete(this.info.invoice_id))
        this.$router.push({ name: 'index' })
      }
    },
    async send() {
      if (!this.internal_invoice_details) {
        let response = await this.$store.dispatch('load', invoices.send(this.info.invoice_id))
        this.internal_invoice_details = response.data
      }
      this.dialog = true
    },
    submit(data) {
      let dataEmpty = _.isEmpty(data)
      this.loading = true

      new Promise((resolve, reject) => {
        if (dataEmpty) reject({'error_message': "請在確定前更改訂單資料"})
        resolve()
      }).then(() => {
        invoices.patch(this.info.invoice_id, data).then(response => {
          this.info = response.data
          this.loading = false

          this.toggleEdit()
        })
      }).catch(error => {
        if (error['error_message']) this.error_message = error['error_message']
        else {
          let e_data = error.response ? error.response.data : {}
          let error_message = ''
          for (let key in e_data) error_message += `${key} : ${e_data[key][0]}`
          this.error_message = error_message
        }
        this.snackbar = true
        this.loading = false
      })
    }
  },
  computed: {
    editing() {
      return Boolean(this.$route.query.edit) === true
    }
  },
  beforeRouteEnter (to, from, next) {
    store.dispatch('load', invoices.get(to.params.invoice_id).then(response => { next(vm => vm.info = response.data) }))
  },
  mounted() {
  }
}
</script>

<style scoped>
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0,0,0,0.4);
  z-index: 1;
}
.hidden {
  opacity: 0;
}

.v-btn-toggle--selected {
  box-shadow: none !important;
}

.fade-down-enter-active, .fade-down-leave-active {
  transition: all .25s;
}
.fade-down-enter, .fade-down-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(50px);
}

.fade-enter-active, .fade-leave-active {
  transition: all .25s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/InvoiceView.vue